import { Component, OnInit, OnDestroy, computed, effect } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { NgClass, NgIf } from '@angular/common';
import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { environment } from '../../../../environments/environment';
import { PromoService } from '../../../shared/promo.service';

@Component({
  selector: 'direct-header',
  template:`
    <div class="header-nav  header-details ">

      <div class="centering-section">

        <div class="icon-header-side" >

          <div class="direct-header-logo" *ngIf="companyName" style="margin-left: 10px;">
            <a href="{{headerlink}}">
              <img src="{{CompanyImageLocation}}" alt="{{companyName}} Logo">
            </a>

            <span *ngIf="!isMobile && isBranded" class="with-experian" >
              <p style="display: inline-block;">data provided by</p> 
              <img src="/assets/ShieldSafe/logo/experian-64px.png" alt="ShieldSafe is partnered with Experian" data-no-retina="">
            </span>
          </div>

        </div>
      

        <div class="call-details-side " [ngClass]=" isMobile ? 'mobile-font' : 'desktop-font' " >
          <div class=" px-0 mx-0">
            <div class=" ">Call For Assistance:</div>
          </div>
          <div class=" px-0 mx-0">
            <a class="" style="text-decoration: none;" href="tel:{{callNumber}}">{{displayedPhoneNumber}}</a>
          </div>

          <div class=" ref-line px-0 mx-0" *ngIf="(customerId != '' && customerId)">
            <div class="">Ref #: {{this.customerId}}</div>
          </div>
        </div>

      </div>

    </div>
  `
  ,
  styleUrls: ['./direct-header.component.scss'],
  host: {'class': 'direct-header'},
  standalone: true,
  imports: [ HttpClientModule, NgIf, NgClass ]
})
export class DirectHeaderComponent implements OnInit, OnDestroy {
  
  CompanyImageLocation = "";
  CompanyMobileImageLocation = "";

  displayedPhoneNumber: string = "";
  callNumber: string = "";
  companyName: string = "";
  private unsubscriber = new Subject<void>();
  isHidden: boolean = false;
  AssociatedBranding: string = "/assets/BLANK_ICON.png";
  isBranded: boolean = true;

  headerBaseUrl: string = "";
  headerlink: string = "/planselection";

  isMobile: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly titleService: Title,
    public directSessionLogic: DirectSessionLogicService,
    public promoService: PromoService,
    private readonly responsive: BreakpointObserver,
  ){
    const customerIdSignal = computed(()=> this.directSessionLogic.trimmedSessionSignal().customerId);
    const couponCodeSignal = computed(()=> this.promoService.couponSignal()?.code);

    effect(() => {
      const customerId = customerIdSignal();
      const couponCode = couponCodeSignal();
      this.buildHeaderLink();
    });
    
  }

  get customerId(): string {
    return (this.directSessionLogic.trimmedSessionSignal().customerId ?? "");
  }

  ngOnInit(): void{
    let companyInfo = environment.CompanyInfo;

    this.displayedPhoneNumber = companyInfo.DisplayedPhoneNumber;
    this.callNumber = "+"+ this.displayedPhoneNumber.replace(/\D/g,"");
    this.companyName = companyInfo.CompanyName;
    this.CompanyImageLocation = companyInfo.AgilityHeaderLogo;
    this.CompanyMobileImageLocation = companyInfo.AgilityHeaderLogoMobile;

    this.AssociatedBranding = companyInfo.AssociatedCompanyBranding;
    if(this.AssociatedBranding.includes("BLANK_ICON")) this.isBranded = false;

    this.headerBaseUrl = environment.ConnectionInfo.MediaPageURL.split("/").reverse()[0];

    this.titleService.setTitle(this.companyName + " Direct");

    this.buildHeaderLink();


    this.responsive.observe([
      Breakpoints.XSmall , Breakpoints.Handset//Breakpoints.Small
        ])
        .subscribe(result => {
          this.isMobile = false; 
          if (result.matches) 
            this.isMobile = true;      
    });


  }


  ngOnDestroy():void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  buildHeaderLink() {
    let couponCode =  "";
    let referenceNumber =  "";
    this.headerlink = this.headerBaseUrl;

    if( this.headerlink.includes(".html")) this.headerlink = "/planselection";

    if(this.directSessionLogic.planSelectedSignal().name?.length != 0) {
      couponCode = this.promoService.couponSignalValue?.code ?? "";
      referenceNumber = this.directSessionLogic.trimmedSessionSignal().customerId ?? "";
    }else{
      couponCode = this.promoService.couponInputSignal() ?? "";
      referenceNumber = this.directSessionLogic.trimmedSessionSignal().customerId ?? "";
    }

    if(couponCode != "" || referenceNumber != "") {
      this.headerlink = this.headerlink + "?";
      if(couponCode != "") {
        this.headerlink += "promo=" + couponCode;
      }
      if(referenceNumber != "") {
        if(couponCode != "") {
          this.headerlink += "&";
        }
        this.headerlink += "appNumber=" + referenceNumber;
      }
    }
  }

  navigateToPlans(){
    this.router.navigate(['/']);
  }
}
